import { Injectable } from '@angular/core';
import { Actions, Store } from '@ngxs/store';
import { BaseQueries } from './base/base.queries';
import { AppStateModel } from './app.state';

@Injectable()
export class AppQueries  extends BaseQueries {
  readonly userProfile$ = this.store.select(state => (state['App'] as AppStateModel).userProfile);
  readonly products$ = this.store.select(state => (state['App'] as AppStateModel).products);
  readonly sponsorOrgs$ = this.store.select(state => (state['App'] as AppStateModel).sponsorOrgs);
  readonly dataSources$ = this.store.select(state => (state['App'] as AppStateModel).dataSources);
  readonly thirdApps$ = this.store.select(state => (state['App'] as AppStateModel).thirdApps);
  readonly dataAll$ = this.store.select(state => (state['App'] as AppStateModel).dataAll);
  readonly provinces$ = this.store.select(state => (state['App'] as AppStateModel).provinces);
  readonly issuers$ = this.store.select(state => (state['App'] as AppStateModel).issuers);
  readonly broadcastHistoryStatus$ = this.store.select(state => (state['App'] as AppStateModel).broadcastHistoryStatus);
  readonly crmStatuses$ = this.store.select(state => (state['App'] as AppStateModel).crmStatuses);
  readonly subjectTypeNewFeed$ = this.store.select(state => (state['App'] as AppStateModel).subjectTypeNewFeed);
  readonly productAssetTypes$ = this.store.select(state => (state['App'] as AppStateModel).productAssetTypes);
  readonly topHoldingTypes$ = this.store.select(state => (state['App'] as AppStateModel).topHoldingTypes);
  readonly articleStatus$ = this.store.select(state => (state['App'] as AppStateModel).articleStatus);
  readonly partnerCorpTypes$ = this.store.select(state => (state['App'] as AppStateModel).partnerCorpTypes);
  readonly quizTypes$ = this.store.select(state => (state['App'] as AppStateModel).quizTypes);
  constructor(
    private store: Store,
    protected actions$: Actions
  ) { super(actions$); }
}
